module.exports = __webpack_public_path__ + "images/closee2d617f7fb1dc49f3fc5c74d4692dfae.svg";